import { render, staticRenderFns } from "./white.vue?vue&type=template&id=27e2534c&scoped=true"
import script from "./white.vue?vue&type=script&lang=js"
export * from "./white.vue?vue&type=script&lang=js"
import style0 from "./white.vue?vue&type=style&index=0&id=27e2534c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0_supports-color@6.1.0___css-loader@_035c03662a22344aa556e5f10fe24304/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e2534c",
  null
  
)

export default component.exports